<template>
  <div class="paginationContainer">
    <el-pagination
      v-if="showPagination&&totalL>10"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPageL"
      :page-sizes="pageSizeRange"
      :page-size="pageSizeL"
      layout="total, sizes, prev, pager, next, jumper"
      this.totalL="total;"
      :total="totalL"
    ></el-pagination>
  </div>
</template>
<script>
import storageUtil from "@lib/storageUtil.js";
import {mapGetters} from "vuex";
export default {
  name: "HelloWorld",
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
     currentPages: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageSizeRange: {
      type: Array,
      default: function() {
        return [10, 30, 50, 100, 150, 200, 500];
      }
    },
    listFlag: {
      type: String,
      required: true
    }
  },
  watch: {
    currentPageL(newValue) {
    }
  },
  data() {
    return {
      currentPageL: 0,
      totalL: 0,
      pageSizeL: 10,
      showPagination: false,
      total: 0
    };
  },
   computed:{
    ...mapGetters(['getUserInfo'])
  },
  mounted() {
    let temp = storageUtil.getSession(this.listFlag);
    if (temp) {
      this.currentPageL = temp.currentPage || this.currentPage;
      this.pageSizeL = temp.pageSize || this.pageSize;
    } else {
      this.currentPageL = this.currentPage;
      this.pageSizeL = this.pageSize;
    }
    this.showPagination = true;
    this.$forceUpdate();
  },
  methods: {
    handleSizeChange(val) {
      let data = {
        listFlag: this.listFlag,
        currentPage: this.currentPageL,
        pageSize: val
      };
      this.pageSizeL=val;
      this.handlerSearchChange(data);
    },
    handleCurrentChange(val) {
      let data = {
        listFlag: this.listFlag,
        currentPage: val,
        pageSize: this.pageSizeL
      };
      this.handlerSearchChange(data);
    },
    setTotal(total) {
      this.totalL = total;
    },
    handlerSearchChange(data) {
      let temp = storageUtil.getSession(this.listFlag);
      if (temp) {
        data = Object.assign(temp, data);
      }
      storageUtil.setSession(this.listFlag, data);
      this.$emit("sizeChange", data);
    },
    getQuery() {
      return {
        listFlag: this.listFlag,
        currentPage: this.currentPageL,
        pageSize: this.pageSizeL
      };
    }
  },
  watch:{
    "getUserInfo.currentUserId"(data){
      this.currentPageL=1;
      storageUtil.removeSessionItem(this.listFlag);
    },
    "currentPages"(data){
      this.currentPageL =1;
      this.$forceUpdate();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.paginationContainer {
  padding-right: 11px;
  text-align: right;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #D81212;
}
.el-select-dropdown__item.selected {
  color: #D81212;
  font-weight: 700;
}
.el-select .el-input.is-focus .el-input__inner {
  border-color: #D81212;
}
.el-pagination__sizes .el-input .el-input__inner:hover {
  border-color: #D81212;
}
.el-input__inner:focus {
  border-color: #D81212;
  outline: 0;
}
.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
  color: #fff !important;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #D81212;
}
</style>

